/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateServiceContractV1Dto } from '../models/CreateServiceContractV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { PatchServiceContractV1Dto } from '../models/PatchServiceContractV1Dto';
import type { ServiceContractV1Dto } from '../models/ServiceContractV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ServiceContractsService {
  /**
   * @param requestBody
   * @returns ServiceContractV1Dto create entity
   * @throws ApiError
   */
  public static serviceContractControllerV1CreateV1(
    requestBody: CreateServiceContractV1Dto,
  ): CancelablePromise<ServiceContractV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/service-contracts',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns ServiceContractV1Dto a entity list
   * @throws ApiError
   */
  public static serviceContractControllerV1FindAllV1(): CancelablePromise<
    Array<ServiceContractV1Dto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/service-contracts',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static serviceContractControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/service-contracts',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param customerId
   * @returns ServiceContractV1Dto a entity list
   * @throws ApiError
   */
  public static serviceContractControllerV1FindManyByCustomerV1(
    customerId: string,
  ): CancelablePromise<Array<ServiceContractV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/service-contracts/by-customer/{customerId}',
      path: {
        customerId: customerId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid contractId
   * @returns ServiceContractV1Dto the entity
   * @throws ApiError
   */
  public static serviceContractControllerV1FindOneV1(
    uuid: string,
  ): CancelablePromise<ServiceContractV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/service-contracts/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid contractId
   * @param requestBody
   * @returns ServiceContractV1Dto the update entity
   * @throws ApiError
   */
  public static serviceContractControllerV1UpdatePartialV1(
    uuid: string,
    requestBody: PatchServiceContractV1Dto,
  ): CancelablePromise<ServiceContractV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/service-contracts/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid contactId
   * @returns ServiceContractV1Dto the entity
   * @throws ApiError
   */
  public static serviceContractControllerV1RemoveOneV1(
    uuid: string,
  ): CancelablePromise<ServiceContractV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/service-contracts/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
}
